import type { SelectedOptionHappy } from "@/happyTheme/interfaces/product/selectedOptionInterface"
import { ref } from "vue"

export const selectOptionsListHappy = ref<Record<number, SelectedOptionHappy>>({})
